import React, { useState } from "react";
import { svgIcons } from "../../../../style/fonts/SvgIcons";

interface Folder {
  folderId: number;
  entityName: string;
  parentId: number | null;
  isFile: boolean;
  children: Folder[];
  isLocked: any
  entityPath: any
  localPath: any
}

const FolderTree = React.memo(({ folders, viewFilePerm, editFilePerm, setIsFile, setSelectedRowId, setSelectedFolderName, setSelectedParentId, setIsLocked }: any) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number | null>(null);
  const [openFolders, setOpenFolders] = useState<Set<number>>(new Set());
  const handleFolderSelection = (folderId: number, folderName: any, parentId: any, isLocked: any, isFile: any) => {
    setSelectedFolderId(folderId);
    setSelectedRowId(folderId);
    setSelectedFolderName(folderName)
    setSelectedParentId(parentId)
    setIsLocked(isLocked)
    setIsFile(isFile)
  };

  const toggleFolder = (folderId: number) => {
    setOpenFolders((prev) => {
      const updated = new Set(prev);
      if (updated.has(folderId)) {
        updated.delete(folderId);
      } else {
        updated.add(folderId);
      }
      return updated;
    });
  };

  const FolderItem: React.FC<{ folder: Folder; path: string, disabled?: boolean }> = ({ folder, path, disabled }) => {
    const isSelected = selectedFolderId === folder.folderId;
    const isOpen = openFolders.has(folder.folderId);

    const handleClick = () => {
      // if (disabled) return;
      handleFolderSelection(folder.folderId, folder.entityName, folder.parentId, folder.isLocked, folder.isFile);
      if (!folder.isFile) toggleFolder(folder.folderId);
    };

    return (
      <div style={{ marginLeft: "20px" }}>
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            backgroundColor: isSelected ? "#8080801f" : "transparent",
            padding: "5px",
            borderRadius: "4px",
            opacity: disabled ? 0.5 : 1,
          }}
          onClick={handleClick}
        // aria-disabled={disabled}
        >
          {!folder.isFile ? (
            <span style={{ marginRight: "8px" }}>{isOpen ? "📂" : "📁"}</span>
          ) : (
            <span style={{ marginRight: "8px" }}>📄</span>
          )}
          <div className="d-flex align-items-center justify-content-between w-100 ">
            {folder.isFile ? (
              <div>
                <p
                  className="mb-0"
                >
                  {/* {`${path} - ${folder.entityName}`} */}
                  {`${folder.entityName}`}

                </p>
              </div>
            ) :
              (
                // <span>{`${path} - ${folder.entityName}`}</span>
                <span>{`${folder.entityName}`}</span>
              )}
            <div className="d-flex gap-3">
              {folder.isFile && folder.localPath !== null ? (
                <>
                  {editFilePerm &&
                    <button className="btn btn-primary p-1">
                      <a
                        href={folder.localPath}
                        target="_blank"
                        className="text-light fs-12"
                        rel="noopener noreferrer"
                        download
                      >
                        {/* {`${folder.entityName}`} */}
                        Edit File
                      </a>
                    </button>
                  }
                </>
              ) :
                (
                  ""
                )

              }

              {folder.isFile ? (
                <>
                  {viewFilePerm &&
                    <button className="btn btn-primary p-1">
                      <a
                        href={folder.entityPath}
                        target="_blank"
                        className="text-light fs-12"
                        rel="noopener noreferrer"
                        download
                      >
                        View File
                      </a>
                    </button>
                  }
                </>
              ) :
                (
                  ""
                )

              }

            </div>

            {/* {disabled &&
            <span className="ms-4">{svgIcons?.LockIcon}</span>
          } */}
          </div>
        </div>
        {/* Render children if it's a folder and is open */}
        {isOpen && !folder.isFile && folder.children.length > 0 && (
          <div>
            {folder.children.map((child, index) => (
              <FolderItem
                key={child.folderId}
                folder={child}
                path={`${path}.${index + 1}`}
                disabled={child?.isLocked === 1}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {folders?.result?.map((folder: Folder, index: number) => (
        <FolderItem key={folder.folderId} folder={folder} path={`${index + 1}`} disabled={folder.isLocked === 1} />
      ))}
    </div>
  );
});

export default FolderTree;
